export interface PricingTier {
  flatPrice: number;
  unitPrice: number;
  upTo: number | null;
}

export interface PricingPlan {
  type: string;
  price: number;
  currency: string;
  currencySymbol: string;
  tiers: PricingTier[];
}

export interface PricingResponse {
  pro_yearly_oct24_s: PricingPlan;
  pro_monthly_oct24_s: PricingPlan;
}

export interface ProcessedPricing {
  monthly: {
    price: number;
    currency: string;
    currencySymbol: string;
    billingText: string;
  };
  yearly: {
    price: number;
    currency: string;
    currencySymbol: string;
    billingText: string;
    monthlyEquivalent: number;
    originalPrice: number;
  };
}

const PRICING_API_URL = 'https://api.bigvu.tv/v0.5/stripe/plans/prices?plans=pro_yearly_oct24_s%2Cpro_monthly_oct24_s';

export const fetchPricingData = async (): Promise<ProcessedPricing> => {
  try {
    const response = await fetch(PRICING_API_URL);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data: PricingResponse = await response.json();
    
    // Process the pricing data
    const monthlyPlan = data.pro_monthly_oct24_s;
    const yearlyPlan = data.pro_yearly_oct24_s;
    
    // Calculate monthly equivalent for yearly plan
    const yearlyMonthlyEquivalent = Math.round(yearlyPlan.tiers[0].unitPrice / 12);
    
    return {
      monthly: {
        price: monthlyPlan.tiers[0].unitPrice,
        currency: monthlyPlan.currency,
        currencySymbol: monthlyPlan.currencySymbol,
        billingText: 'Billed monthly'
      },
      yearly: {
        price: yearlyPlan.tiers[0].unitPrice,
        currency: yearlyPlan.currency,
        currencySymbol: yearlyPlan.currencySymbol,
        billingText: `$${yearlyPlan.tiers[0].unitPrice} Billed yearly`,
        monthlyEquivalent: yearlyMonthlyEquivalent,
        originalPrice: monthlyPlan.tiers[0].unitPrice
      }
    };
  } catch (error) {
    console.error('Error fetching pricing data:', error);
    
    // Fallback to hardcoded pricing if API fails
    return {
      monthly: {
        price: 39,
        currency: 'usd',
        currencySymbol: '$',
        billingText: 'Billed monthly'
      },
      yearly: {
        price: 229,
        currency: 'usd',
        currencySymbol: '$',
        billingText: '$229 Billed yearly',
        monthlyEquivalent: 19,
        originalPrice: 39
      }
    };
  }
};
